<template>
  <v-navigation-drawer class="elevation-5" app dark>

    <div class="py-5 px-2 d-flex flex-column justify-center align-center text-center">
      <img src="@/assets/images/symbol.gif" width="100">
      <span class="py-2 white--text title">ระบบบริหารจัดการเว็บไซต์กองบริหารงานบุคคล</span>
    </div>

    <v-divider/>

    <v-list dense shaped class="py-5">
      <div v-for="(item, index) in menu" :key="index">
        <v-subheader v-if="item.header">{{ item.header }}</v-subheader>
          <div v-for="(menu, index) in item.children" :key="index">
            <div v-if="checkPermission(menu.permissions ? menu.permissions : null)">
            <v-list-item v-if="menu.type === 'ITEM'" :to="menu.to">
              <v-list-item-icon>
                <v-icon>{{ menu.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="py-2">
                <v-list-item-title class="wrap-text">{{ menu.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
            <v-list-group active-class="white--text" v-else-if="menu.type === 'GROUP'" no-action :prepend-icon="menu.icon" :disabled="menu.disabled">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title class="wrap-text">{{ menu.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item exact exact-active-class="white--text" v-for="(submenu, idx) in menu.children" :key="idx" :to="submenu.to">
                <v-list-item-content>
                  <v-list-item-title class="wrap-text">{{ submenu.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </div>
        </div>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import menu from './menu';

export default {
  computed: {
    menu() { return menu }
  },
  methods: {
    checkPermission(permissions) {
      if(permissions && this.user_data) {
        const permission = permissions.filter(item => item == this.user_data.user_type_id);
  
        if(permission.length > 0) { return true } else { return false }
      } else {
        return true;
      }
    }
  }
}
</script>